// removed by extract-text-webpack-plugin
module.exports = {"container":"js-components-CourseList-CourseList-module__container--2XTxl","courseList":"js-components-CourseList-CourseList-module__courseList--101OR"};